import { API_BASE_URL } from '../config/api';

const SESSION_KEY = 'visit_reported';

/**
 * Meldet anonym, woher der Besuch kam (Referrer, UTM-Parameter, Einstiegsseite) - hoechstens einmal pro
 * Browser-Sitzung. Es wird nichts im Browser gespeichert ausser der Sitzungsmarke, und der Server speichert
 * weder IP-Adresse noch Kennung (siehe VisitsController). Bei eingeschaltetem "Do Not Track" wird nichts gesendet.
 * Fehler werden bewusst verschluckt: die Zaehlung darf die App nie stoeren.
 */
export const trackVisit = (isLoggedIn: boolean): void => {
  try {
    if (navigator.doNotTrack === '1') return;
    if (sessionStorage.getItem(SESSION_KEY)) return;
    sessionStorage.setItem(SESSION_KEY, '1');

    const params = new URLSearchParams(window.location.search);
    let referrer = '';
    try {
      // Verweise von der eigenen Seite (z.B. nach Neuladen) sind keine Herkunft.
      if (document.referrer && new URL(document.referrer).hostname !== window.location.hostname) {
        referrer = document.referrer;
      }
    } catch {
      // ungueltiger Referrer -> als direkt behandeln
    }

    void fetch(`${API_BASE_URL}/visits`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        path: window.location.pathname,
        referrer,
        utmSource: params.get('utm_source'),
        utmMedium: params.get('utm_medium'),
        utmCampaign: params.get('utm_campaign'),
        language: navigator.language,
        isLoggedIn,
      }),
    }).catch(() => undefined);
  } catch {
    // sessionStorage gesperrt o.ae. -> nicht zaehlen
  }
};
